var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tuwen"},[_c('div',[_c('p',[_vm._v("LOGO")]),_c('div',{staticClass:"tuwen_upload"},[_c('upload',{attrs:{"image":_vm.form.data.logo},on:{"uploadOk":_vm.uploadOk}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }